const THREE = require('three') 
import { DEG_TO_RAD, clamp  } from '@/helpers/MathUtils'
import DoorIris from '@/components/Stage/intro/doors-iris'
 
class Doors extends THREE.Group {

  constructor(config) {

    super(); 

    this.renderer = config.renderer;
    this.count = 0;
    this.position.y = -400;
    //this.position.x = 35;
    this.position.z = -600; 

    this.setup();
    this.resize() 
  } 

  setup() {

    this.door_plane_top = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(window.innerWidth, 300), 
      new THREE.MeshBasicMaterial({ color: 0x792e48 })
    );
    this.door_plane_top.position.y = 250;
    this.door_plane_top.position.z = -200; 
    this.add( this.door_plane_top) 

    var ceilingTex = new THREE.TextureLoader().load(require('@/assets/img/eye.png'))
    var ceilingMat = new THREE.MeshBasicMaterial({
      map: ceilingTex,
      transparent: true
    });
    this.door_plane_ceiling = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(70, 70),
      ceilingMat
    );
    
    this.door_plane_ceiling.rotation.x = (30 * DEG_TO_RAD);
    this.door_plane_ceiling.position.y = 100;
    this.door_plane_ceiling.position.z = 20;
    this.add(this.door_plane_ceiling) 

    var floorTex = new THREE.TextureLoader().load(require('@/assets/img/floor.png'))
    var floorMat = new THREE.MeshBasicMaterial({
        map: floorTex,
        transparent: true, 
        side :THREE.DoubleSide 
      });
    floorTex.wrapS = THREE.RepeatWrapping;
    floorTex.wrapT = THREE.RepeatWrapping;
    floorTex.repeat.set( 4, 4 );
    this.door_plane_floor = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1000, 1000),  
      floorMat
     // new THREE.MeshBasicMaterial({ color: 0x792e48 , side :THREE.DoubleSide })
    );
    this.door_plane_floor.rotation.x = (90 * DEG_TO_RAD);
    this.door_plane_floor.position.y = -150; 
    this.add(this.door_plane_floor)

    // this.cave_plane_right = new THREE.Mesh(
    //   new THREE.PlaneBufferGeometry(1000, 400), 
    //   new THREE.MeshBasicMaterial({ color: 0xfdff33 })
    // );  
    // this.cave_plane_right.position.y = -510;
    // this.cave_plane_right.position.x = 550;
    // this.cave_plane_right.position.z = -30;


    // this.cave_plane_top = new THREE.Mesh(
    //   new THREE.PlaneBufferGeometry(window.innerWidth, 80), 
    //   new THREE.MeshBasicMaterial({ color: 0xfdff33 })
    // );  
    // this.cave_plane_top.position.y = -290;
    // this.cave_plane_top.position.x = -100;
    // this.cave_plane_top.position.z = -30;

    // this.cave_plane_bottom = new THREE.Mesh(
    //   new THREE.PlaneBufferGeometry(window.innerWidth, 100), 
    //   new THREE.MeshBasicMaterial({ color: 0xfdff33 })
    // );  
    // this.cave_plane_bottom.position.y = -500;
    // this.cave_plane_bottom.position.x = -100;
    // this.cave_plane_bottom.position.z = -25;




    this.bg = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024 * 0.4, 1024 * 0.4), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(require('@/assets/img/doors/bg.png')),
        transparent: true
      })
    ); 
    this.bg.position.z = -200; 
    this.bg.position.y = -10; 
    this.bg.position.x = 10; 
    //this.bg.position.x = -200;
 
    this.entrance = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024 * 0.18, 1024 * 0.18), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(require('@/assets/img/doors/entrance.png')),
        transparent: true
      })
    ); 
    this.entrance.position.z = 0;

    this.ramp = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024 * 0.18, 1024 * 0.18), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(require('@/assets/img/doors/ramp.png')),
        transparent: true
      })
    ); 
    this.ramp.position.z = 50;  
    this.ramp.position.y = -75;  
    this.ramp.rotation.x = -20 * DEG_TO_RAD;  
    
    this.doorIris =  new DoorIris({
      renderer : this.renderer
    });

    this.add(this.bg); 
    this.add(this.entrance); 
    this.add(this.ramp); 
    this.add(this.doorIris); 

  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img);   
    texture.needsUpdate = true;
    return texture;
  }

  updateRoute(val) {  
    this.doorIris.updateRoute(val) 
  }

  tick(scroll_ratio){
    //if(scroll_ratio) {
      this.doorIris.tick();
      //this.doorIris.visible = true;
    // } else {
    //   this.doorIris.visible = false;
    // }

    
    if(scroll_ratio > 0.8){
      this.door_plane_top.visible  = true; 
    } else {
      this.door_plane_top.visible  = false; 
    }
  }

  resize() {
    this.doorIris.resize();
  }

}

export default Doors